import _defineProperty from "@babel/runtime/helpers/defineProperty";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../common/constants/proptypes/CommonPropTypes";
import { SEARCH } from "../../../constants/perspectives";
import AddonDiscoveryPropTypes from "../../../constants/proptypes/AddonDiscoveryPropTypes";
import { resolveNewPerspectiveFromTransitionFilters } from "../../../utils/transitions";
import FiltersLink from "./FiltersLink";
export default class DiscoverFiltersLink extends Component {
  render() {
    const newPerspective = resolveNewPerspectiveFromTransitionFilters(this.props.newFilters);
    let href;
    if (newPerspective === SEARCH) {
      href = this.props.filtersContext.get('searchFacetHrefResolver') ? this.props.filtersContext.get('searchFacetHrefResolver')({
        filters: this.props.newFilters
      }) : '#';
    } else {
      href = this.props.filtersContext.get('discoverFacetHrefResolver') ? this.props.filtersContext.get('discoverFacetHrefResolver')({
        filters: this.props.newFilters
      }) : '#';
    }
    return /*#__PURE__*/React.createElement(FiltersLink, {
      className: this.props.className,
      href: href,
      onClick: this.props.onClick,
      newFilters: this.props.newFilters,
      newPerspective: newPerspective
    }, this.props.children);
  }
}
_defineProperty(DiscoverFiltersLink, "propTypes", {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  newFilters: CommonPropTypes.filters.isRequired,
  filtersContext: AddonDiscoveryPropTypes.filtersContext.isRequired,
  onClick: PropTypes.func
});